import { Backdrop as MUIBackdrop } from '@material-ui/core';
import { LoadingSpinnerIconTwoTone } from '@room-match/shared-ui-components';
import React from 'react';

import { useStyles } from './Backdrop.styles';

type Props = {
  isLoading?: boolean;
};
const Backdrop: React.FC<Props> = ({ isLoading = false }) => {
  const classes = useStyles();
  return (
    <MUIBackdrop className={classes.backdrop} open={isLoading}>
      <LoadingSpinnerIconTwoTone style={{ fontSize: '10em' }} />
    </MUIBackdrop>
  );
};

export default Backdrop;
